import { Injectable } from '@angular/core';
import { BaseCadouhApiService } from '../../../shared/services/base-cadouh-api.service';
import { Observable } from 'rxjs';
import { Order, OrderAssignmentLog } from '../models/order';
import { LimitOffsetPagination } from '../../../shared/models/limit-offset-pagination';
import { GetOrdersResponse } from '../models/get-orders-response';

@Injectable({
  providedIn: 'root'
})
export class OrdersApiService extends BaseCadouhApiService {

  getOrders(
    pagination: LimitOffsetPagination,
    status = '',
    search: string = '',
    filters: Record<string, string | number> = {}
  ): Observable<GetOrdersResponse> {
    const params = new URLSearchParams({
      limit: String(pagination.limit),
      offset: String(pagination.offset),
      status,
      search,
    });
    for (const [k, v] of Object.entries(filters)) {
      if (v !== null && v !== undefined && v !== '') params.set(k, String(v));
    }
    return this.http.get<GetOrdersResponse>(
      `${this.baseUrl}/giftshop/orders/?${params.toString()}`,
      { headers: this.getRequestHeadersWithToken() }
    );
  }


  getOrderByUUID(uuid:string): Observable<Order>{
    return this.http.get<Order>(`${this.baseUrl}/giftshop/orders/${uuid}/`, { headers: this.getRequestHeadersWithToken() });
  }

  updateOrderStatus(uuid:string, status:string): Observable<{status:string}>{
    return this.http.patch<{status:string}>(`${this.baseUrl}/giftshop/orders/update-status/${uuid}/`, { status: status }, { headers: this.getRequestHeadersWithToken() });
  }

  // Delivery-admin: assign a driver, change to another, or unassign (driverId = null).
  assignDriver(uuid: string, driverId: number | null): Observable<Order> {
    return this.http.post<Order>(`${this.baseUrl}/giftshop/orders/${uuid}/assign-driver/`, { driver_id: driverId }, { headers: this.getRequestHeadersWithToken() });
  }

  getOrderAssignmentHistory(uuid: string): Observable<OrderAssignmentLog[]> {
    return this.http.get<OrderAssignmentLog[]>(`${this.baseUrl}/giftshop/orders/${uuid}/assignment-history/`, { headers: this.getRequestHeadersWithToken() });
  }

  exportOrders(
    status = '',
    search: string = '',
    filters: Record<string, string | number> = {}
  ): Observable<Blob> {
    const params = new URLSearchParams({ status, search });
    for (const [k, v] of Object.entries(filters)) {
      if (v !== null && v !== undefined && v !== '') params.set(k, String(v));
    }
    return this.http.get(
      `${this.baseUrl}/giftshop/orders/export/?${params.toString()}`,
      {
        headers: this.getRequestHeadersWithToken(),
        responseType: 'blob',
      },
    );
  }
}
